import { useEffect, useState } from 'react';
import { Nav,Card } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
// import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import SessionUtil from '../util/SessionUtil';
function GoalAchievedCard({ data, title, page, percentageTop }) {

    const { t } = useTranslation(); // Use t instead of lang
    const storedType = SessionUtil.getTypeUser();
    // const [percentage, setPercentage] = useState(60);
    const [list, setList] = useState([
        { id: 1, title: 'Delivery User', percentage: 70 },
        { id: 2, title: 'Operation User', percentage: 40 },
    ]);

    useEffect(() => {
        if (page === 'store' || page === 'driver') {
            setList(data);
            // setPercentage(percentageTop)
        }

    }, [list, data, page, percentageTop])

    return (
        <Card className="border-0 p-3 rounded-24 card-custome mb-5">
            {/* <Card.Body> */}
                {/* <div className='d-flex gap-4 align-items-center'>
                    <div className='w-h-circular-progressbar'>
                        <CircularProgressbarWithChildren value={percentage} >
                            <div className="text-center vector-style">
                                <Image alt="image"   src='/images/vector.png' />
                            </div>
                        </CircularProgressbarWithChildren>
                    </div>
                    <div>
                        <p className='mb-0 fw-bold fs-4'>{percentage}%</p>
                        <span className='subtitle font-medium font-14'>{page === 'store' || page === 'driver' ? title : t('Goal Achieved')}</span>
                    </div>
                </div>
                <div className='my-3'>
                    <span className='subtitle font-medium font-14'>
                        {page === 'store' || page === 'driver' ?
                            <span>{percentageTop}%  {t('of sales achived by')} {title} {t('so')} {title}, {t('is')} </span>
                            : t('goal_achieved_text')} </span>
                    <strong>{page === 'store' ? t('First Top Store') : page === 'driver' ? t('First Top Driver') : t('Employee')}</strong>
                </div>
                {list.map((item, index) => {
                    return (
                        <div key={index} className='d-flex justify-content-between'>
                            <p className='subtitle font-medium font-14 mb-2'>{t(item.title)}</p>
                            <p className='fw-bold fs-6 mb-2'>{item.percentage}%</p>
                        </div>
                    )
                })} */}

                {storedType === '4' && <Nav.Link href="/register" className='btn-outline-blue w-100 mt-2'>{t('Add Account')}</Nav.Link>}
            {/* </Card.Body> */}
        </Card>
    );
}

export default GoalAchievedCard;